import { POOL_NARRATION_TARGETS, BOARD_TARGETS, TriggerActions, findTriggerToken, scriptShowsTarget } from '../../constants/constants';

const BOARD_REVEAL_TARGETS = [...POOL_NARRATION_TARGETS, ...BOARD_TARGETS];

// Fallback only: a Formative testlet resolves ITEM_IDLE_TIMEOUTS_MS.formative through
// getIdleTimeoutsForStory. Kept equal to it so a missing override cannot quietly halve the
// time a child has to answer.
export const IDLE_ENCOURAGEMENT_TIMEOUT = 20000;
export const IDLE_SUBMIT_TIMEOUT = 60000;

export {
  HIGHLIGHT_DURATION,
  MAX_REPLAYS,
  TIME_BETWEEN_OPTIONS as TIME_BETWEEN_POOL_ITEMS,
  TIME_BETWEEN_SILENT_OPTIONS as TIME_BETWEEN_SILENT_POOL_ITEMS,
} from '../../constants/assessmentScreenTimings';

export const CONTEXT_SCREEN_OVERLAY_TARGET = 'repeatOverlay';
export const CONTEXT_SCREEN_OVERLAY_INPUT_TARGET = 'repeatOverlayInput';

const spokenText = (segment) => segment.replace(/\[[^\]]*\]/g, ' ').replace(/\s+/g, ' ').trim();

export function parseContextScreen(verbalInstructions) {
  const script = String(verbalInstructions || '');
  const overlay = findTriggerToken(script, TriggerActions.Show, [CONTEXT_SCREEN_OVERLAY_TARGET]);
  if (!overlay) return null;
  // Through the token's end, so a board target sharing it still disqualifies the screen.
  if (scriptShowsTarget(script.slice(0, overlay.end), BOARD_REVEAL_TARGETS)) return null;
  // A context screen hands straight over: nothing at all sits between the two overlay
  // tokens. listeningComprehension reaches this through the shared MMC render case and
  // must not match -- it coaches the overlay buttons there, either as speech or, for a
  // continuation testlet, as bare [highlight:repeatOverlay*] tokens (build_items.py).
  const overlayInput = findTriggerToken(script, TriggerActions.Show, [CONTEXT_SCREEN_OVERLAY_INPUT_TARGET]);
  if (!overlayInput || overlayInput.start < overlay.end) return null;
  if (script.slice(overlay.end, overlayInput.start).trim()) return null;
  return {
    narration: spokenText(script.slice(0, overlay.start)),
  };
}

export const nextFrame = () => new Promise((resolve) => setTimeout(resolve, 0));
